import useIsLoggedIn from "../../hooks/useIsLoggedIn";
import LayoutProtected from "./Protected";
import LayoutUnverified from "./Unverified";

const LayoutUniversal = () => {
    const isLoggedIn = useIsLoggedIn();

    return (
        isLoggedIn ? <LayoutProtected allowedRoles={["teacher", "principal", "student"]} /> : <LayoutUnverified />
    )
}

export default LayoutUniversal